var option_default = {
  "option": "dGM3f",
  "user_choice": "mMlSH",
  "check": "Acp-n",
  "image": "qwwjE",
  "input": "IoKQK",
  "title": "_-0PH9",
  "centered": "PD7Lj",
  "with_result": "jsoA-",
  "list": "CjyOG",
  "with_image": "z1cDd",
  "progress": "P1Gm0",
  "progress_value": "tfrLK",
  "label": "_7Cw8w",
  "cta": "BxhNJ",
  "adornment_icon": "aG5Ry",
  "remove": "sXO-K",
  "removeButton": "gc5s6",
  "removeButtonIcon": "ze7bG",
  "overlay": "oVBRK",
  "shown": "X24Vr",
  "dark": "u71JJ",
  "spinner": "owZbQ",
  "spin": "qFZDO"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
